import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/shared/failure.svg'


const _hoisted_1 = { class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" }
const _hoisted_2 = { class: "bg-white rounded-lg p-6 max-w-md w-full mx-4" }
const _hoisted_3 = { class: "flex justify-center mb-4" }
const _hoisted_4 = {
  key: 0,
  role: "alert",
  class: "flex gap-2 w-full justify-center p-2.5 text-sm leading-5 text-center text-red-900 bg-red-50 rounded-lg max-md:flex-wrap",
  style: {"max-height":"80px","overflow-y":"auto"}
}
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900 mb-4" }
const _hoisted_6 = { class: "text-gray-600 mb-6" }
const _hoisted_7 = { class: "flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Error Icon",
                  class: "w-4 h-4"
                })
              ], -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h3", _hoisted_5, " Delete \"" + _toDisplayString(_ctx.layoutName) + "\" ", 1),
      _createElementVNode("p", _hoisted_6, " Are you sure you want to delete \"" + _toDisplayString(_ctx.layoutName) + "\"? This action cannot be undone. ", 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "text-gray-700 bg-gray-100 px-4 py-2 rounded-md font-inter text-sm font-medium",
          onClick: _ctx.handleCancel
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Cancel ")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "bg-red-600 text-white px-4 py-2 rounded-md font-inter text-sm font-medium",
          disabled: _ctx.isDeleting,
          onClick: _ctx.handleDelete
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isDeleting ? "Deleting..." : "Delete"), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}